import { ReactNode } from "react";
import { FirmwareDataList } from "../api/Firmwares";

interface FirmwareInfoTableProps {
    firmwareList: FirmwareDataList;
    setRelease: (isRelease: boolean, id: number) => void;
    deleteEntry: (id: number) => void;
}

function FirmwareInfoTable({ firmwareList, setRelease, deleteEntry }: FirmwareInfoTableProps): ReactNode {
    return (
        <table className='table table-striped' aria-labelledby="tableLabel">
            <thead>
                <tr>
                    <th>Version</th>
                    <th>Devise version</th>
                    <th>Time create</th>
                    <th>Is release</th>
                    <th>Length</th>
                    <th>Apply</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {firmwareList.map(firmwareInfo =>
                    <tr key={firmwareInfo.version}>
                        <td>{firmwareInfo.version}</td>
                        <td>{firmwareInfo.deviceVersion}</td>
                        <td>{firmwareInfo.timeCreate}</td>
                        <td>{firmwareInfo.isRelease ? "Release" : "Debug"}</td>
                        <td>{firmwareInfo.length}</td>
                        <td>
                            <button
                                className="btn btn-primary"
                                onClick={() => { setRelease(!firmwareInfo.isRelease, parseInt(firmwareInfo.id)); }}
                            >
                                {firmwareInfo.isRelease ? "To debug" : "To release"}
                            </button>
                        </td>
                        <td>
                            <button
                                className="btn btn-danger"
                                onClick={() => { deleteEntry(parseInt(firmwareInfo.id)); }}
                            >
                                X
                            </button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}

export default FirmwareInfoTable;